import MyApp from "./MyApp";
import { BrowserRouter } from "react-router-dom";

const App = () => {
  return (
    <BrowserRouter>
      <MyApp />
    </BrowserRouter>
  );
};

export default App;
